import React, { useState, useEffect } from "react";
import LogoForModal from "../../LogoForModal";
import Button from "../../styled/Button/Button";
import BigNumber from "bignumber.js";
import { ButtonContainer, InputWrapper } from "./style";
// import { LogoUpperContainer, ,AmountDiv,} from "./style.js";
import InputAmount from "../../InputAmount/InputAmount";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  stake,
  Approve,
  Allowance,
  getFirstLoadData,
  getSecondLoadData
} from "../../../common/BPADBlockStakeContract";
import { useSelector, useDispatch } from "react-redux";
/* import { setApproved } from "../../../store/actions/globalActions"; */
import { setApproved, setFirstLoadData, setSecondLoadData } from "../../../store/actions/globalActions";
import { MINIMUM_LOCK, MINIMUM_STAKE } from '../../../constants/index'

function Flexible({ onHide, onLoadStart, onLoadStop }) {
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const { currentChainId, networkIdFromURL, isApproved } = useSelector(
    (state) => state.global
  );
  const { poolTknSymbol } = useSelector(
    (state) => state.global.tknSymbol
  );
  const { isLogin } = useSelector((state) => state.login);
  const dispatch = useDispatch();
  const { corePoolContract, corePoolAddress } = useSelector(
    (state) => state.global
  );
  const { poolFactoryAddress } = useSelector(
    (state) => state.global.poolAddresses
  );
  const { poolFactoryContract, rewardContract, poolTokenContract } =
    useSelector((state) => state.global.poolContracts);
  const { poolTokenDecimal } = useSelector(
    (state) => state.global.rewardDecimalPoolTokenDecimal
  );
  const { rewardTokenPerBlock } = useSelector(
    (state) => state.global.poolDetailsFromFactory
  );
  const { APY, tokenBalance } = useSelector(
    (state) => state.global.actionBasedData
  )

  function success(Message) {
    toast(Message);
  }

  function Amount(amount) {
    setAmount(amount);
  }

  const fetchAndSetFirstLoadData = async (
    corePoolContract,
    corePoolAddress,
    poolFactoryContract,
    poolTokenContract,
    chainId,
    rewardPerBlock
  ) => {
    let data = await getFirstLoadData(
      corePoolContract,
      corePoolAddress,
      poolFactoryContract,
      poolTokenContract,
      chainId,
      rewardPerBlock
    )
    dispatch(
      setFirstLoadData(
        data.Apy,
        data.balanceOfTvl,
        data.totalStakevalue,
        data.totalStake,
        data.reward,
      )
    )
  }

  const fetchAndSetSecondLoadData = async (
    corePoolContract,
    poolFactoryContract,
    poolFactoryAddress,
    rewardContract,
    poolTokenContract,
  ) => {
    let data = await getSecondLoadData(
      corePoolContract,
      poolFactoryContract,
      poolFactoryAddress,
      rewardContract,
      poolTokenContract
    )
    dispatch(
      setSecondLoadData(
        data.tokenBalance,
        data.EligibleunStake,
        data.RewardDiff,
        data.rewardDistributed,
        data.rewardBalanceOf,
      )
    )
  }

  async function isStaked(staked) {
    if (staked) {
      await Promise.all([
        fetchAndSetFirstLoadData(corePoolContract,
          corePoolAddress,
          poolFactoryContract,
          poolTokenContract,
          networkIdFromURL,
          rewardTokenPerBlock),
        fetchAndSetSecondLoadData(corePoolContract,
          poolFactoryContract,
          poolFactoryAddress,
          rewardContract,
          poolTokenContract)
      ])
    }
  }

  const startLoading = () => {
    setLoading(true);
    onLoadStart && onLoadStart();
  };

  const stopLoading = () => {
    setLoading(false);
    onLoadStop && onLoadStop();
  };

  const Staked = async () => {
    if (!isLogin) {
      success("Please connect to wallet before Staking");
      return "";
    }
    console.log("currentChainId", currentChainId);

    if (currentChainId !== networkIdFromURL) {
      success("Wrong Network");
      return "";
    }

    if (amount <= 0) {
      success("Amount must be greater than zero");
      return "";
    }

    if (amount < MINIMUM_STAKE) {
      success("Minimum stake amount is 50 BLOS");
      return "";
    }

    if (tokenBalance < amount) {
      success("Amount must be smaller than total balance");
      return "";
    }



    if (
      amount > 0 &&
      tokenBalance >= amount &&
      currentChainId === networkIdFromURL
    ) {
      try {
        startLoading();
        let totalAmount = new BigNumber(amount).times(new BigNumber(10).pow(poolTokenDecimal).toString()).toString();
        const Transaction = await stake(
          totalAmount,
          (parseInt(Date.now().toString().slice(0, 10)) + MINIMUM_LOCK).toString(),
          isStaked,
          corePoolContract
        );
        if (Transaction) {
          success(`${amount} token staked successfully for 1 week`);
        } else {
          success("Transaction Cancelled");
        }
        stopLoading();
        onHide && onHide();
      } catch (error) {
        console.log(error)
      }
    }
  };

  const handleApprove = async () => {
    startLoading();
    await Approve(corePoolAddress, poolTokenContract);
    const allowance = await Allowance(corePoolAddress, poolTokenContract);
    if (allowance === "0") {
      dispatch(setApproved(1));
      success("Stake Approval failed");
    } else {
      dispatch(setApproved(2));
      success("Stake Approved Successfully");
    }
    stopLoading();
  };

  return (
    <div>
      <LogoForModal />
      <ButtonContainer>
        <InputWrapper>
          <InputAmount
            amount="Amount"
            balance={
              tokenBalance && poolTknSymbol
                ? `Balance: ${tokenBalance?.toFixed(3) + " " + poolTknSymbol
                }`
                : "Balance: 0"
            }
            weight="Weightage: 1.0x"
            apy={APY ? `Est. APY: ${APY !== "NaN" ? APY + "%" : "0%"}` : "Est. APY: 0"}
            onChange={Amount}
          />
        </InputWrapper>
        {isApproved === 2 && (
          <Button
            loading={loading}
            disabled={loading}
            loadingContent={"Staking..."}
            disableHelper="Enter valid amount"
            style={{ marginTop: "15px" }}
            onClick={() => Staked()}
            color="primary"
            modal
          >
            Stake
          </Button>
        )}
        {isApproved === 1 && (
          <Button
            loading={loading}
            disabled={loading}
            loadingContent={"Approving..."}
            style={{ marginTop: "15px" }}
            onClick={() => handleApprove()}
            color="primary"
            modal
          >
            Approve
          </Button>
        )}
        {isApproved === 0 && (
          <Button
            loading={true}
            disabled={true}
            loadingContent={"Fetching..."}
            style={{ marginTop: "15px" }}
            color="primary"
            modal
          >
            Fetching...
          </Button>
        )}
      </ButtonContainer>
    </div>
  );
}

export default Flexible;
